module.exports = __webpack_public_path__ + "media/images/home/flow_r_4-37d4f38a9c20d0d54b6b3ed307b6ea4f.svg";